<template>
    <div :class="rootCssClass" class="lazy-select">
        <div :class="{ 'no-value': selected == null && !emptyValue }" class="label-value"
             @click.stop="toggleOpen">

            <div class="label-container">
                <span class="label">{{ label }}</span>

                <span class="value">
                    <template v-if="selectedItem != null">
                        {{ selectedItem.title }}
                    </template>
                    <template v-else-if="selected != null">
                        Unknown {{ selected }}
                    </template>
                    <template v-else>
                        {{ emptyValue }}
                    </template>
                </span>
            </div>

            <div class="actions">
                <IconChevron class="icon" />
            </div>
        </div>

        <div v-show="opened" ref="container" class="option-dialog">
            <div class="header">
                <div class="title">{{ label }}</div>
                <button class="no-border iconed" @click="close">
                    <IconClose />
                </button>
            </div>

            <div v-if="showSearch" :class="{ filled: !!searchText }" class="search-field">
                <input ref="search"
                       v-model="searchText"
                       :placeholder="placeholder"
                       class="search"
                       type="text"
                       @input="doSearch()"
                />
                <span class="icon" @click="resetSearch()"></span>
            </div>

            <div v-show="status === 'waiting'"
                 class="message waiting">
                <slot :searchText="searchText"
                      name="waiting"
                >Подождите, идет поиск...
                </slot>
            </div>

            <div v-show="status === 'failure'"
                 class="message failure">
                <slot :message="message"
                      :searchText="searchText"
                      name="failure"
                >{{ message }}
                </slot>
            </div>

            <div v-show="status === 'success'" class="container">
                <component :is="infinityScrollComponent" :root="$refs.container" v-bind="infinityScrollAttrs">
                    <template>
                        <div v-show="selected != null" class="message">
                            <button class="no-border primary" @click.stop="resetValue">Очистить выбранное</button>
                        </div>

                        <div v-if="showAppendFirst"
                             v-show="needShowAppend"
                             class="append first"
                             @click="doAppend()">
                            <slot :searchText="searchText"
                                  name="append"
                            >Добавить объект «{{ searchText }}»
                            </slot>
                        </div>

                        <Node v-for="it in filteredRoot"
                              v-show="it.visible"
                              :key="it.key"
                              :flat-groups="flatGroups"
                              :selectable-groups="selectableGroups"
                              :selected="selected"
                              :value="it"
                              @selected="select($event)">
                            <template #default="{item, title, disabled}">
                                <slot :disabled="disabled"
                                      :item="item"
                                      :title="title"
                                      name="option"
                                >{{ title }}
                                </slot>
                            </template>
                        </Node>

                        <div v-show="isEmpty"
                             class="message">
                            <slot :searchText="searchText"
                                  name="absent"
                            >Ничего не найдено
                            </slot>
                        </div>

                        <div v-if="!showAppendFirst"
                             v-show="needShowAppend"
                             class="append"
                             @click="doAppend()">
                            <slot :searchText="searchText"
                                  name="append"
                            >Добавить объект «{{ searchText }}»
                            </slot>
                        </div>
                    </template>

                    <template #loader>
                        <div />
                    </template>
                </component>
            </div>
            <div v-if="infinityScroll" class="footer">
                <slot :itemCount="infinityScrollParams.itemCount"
                      :loading="infinityScrollParams.loading"
                      :optionsCount="originalRoot.length"
                      name="footer">
                    <div class="item-count">
                        Загружено: {{ originalRoot.length }} из {{ infinityScrollParams.itemCount }}
                    </div>
                    <div class="loader-container">
                        <Loader v-show="infinityScrollParams.loading" class="loader" />
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
import Node from '../node.scalar.vue';
import { ResetToEmpty, SearchMixin, SelectBase, ScalarValueMixin } from '@dsee/components/selects/select.base.js';
import { AdhocProps } from './adhoc.js';

export default {
    mixins: [ SelectBase, ScalarValueMixin, SearchMixin, ResetToEmpty, AdhocProps ],
    components: { Node },
};
</script>

<style lang="scss" scoped>
.lazy-select {
    @import '~@dsee/components/selects/select.base.scss';
    @import './adhoc.scss';
    @import '~@dsee/components/selects/infinity.scroll.scss';
}
</style>
